import __request__ from "routing/request";
export function metrics(requestOptions) {
  return __request__("GET", "/system/metrics", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function multipleMetrics(Requestedmetrics, requestOptions) {
  return __request__("POST", "/system/metrics/multiple", Requestedmetrics, {}, {
    "Accept": []
  }, requestOptions);
}
export function metricNames(requestOptions) {
  return __request__("GET", "/system/metrics/names", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function byNamespace(namespace, requestOptions) {
  return __request__("GET", `/system/metrics/namespace/${namespace}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function singleMetric(metricName, requestOptions) {
  return __request__("GET", `/system/metrics/${metricName}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
